import { useEffect, useState } from 'react';

import { IGame, IGroupEnrollment, IGroupGameGame } from '../../../../store/player/games/store';

import { sortBy } from '../../../../contrib/sortBy';

type TUseSortedGroupGames = (game?: IGame) => [IGroupEnrollment[], IGroupGameGame[]];

export const useSortedGroupGames: TUseSortedGroupGames = game => {
  const [enrollments, setEnrollments] = useState<IGroupEnrollment[]>([]);
  const [groupGames, setGroupGames] = useState<IGroupGameGame[]>([]);

  useEffect(() => {
    if (game) {
      const gameGroupGames = game.group.games;

      const groupGamesSortedBySeat: IGroupGameGame[] = sortBy(gameGroupGames, 'asc', 'seat');

      setGroupGames(groupGamesSortedBySeat);

      const gameSortedEnrollments = groupGamesSortedBySeat.flatMap(
        groupGame => groupGame.enrollment
      );

      setEnrollments(gameSortedEnrollments);
    }
  }, [game]);

  return [enrollments, groupGames];
};
